import { POR_PESO_VARIAVEL_SEM_UNIDADE, getSubTotal } from '../../../utils';

function renameItensUIDD(itens) {
  const arrayNew = itens.slice();
  for (let i = 0; i < itens.length; i += 1) {
    arrayNew[i].uidd = `${arrayNew[i].produto.nome}${i}`;
  }
  return arrayNew;
}

function isEstoqueAcabado(item) {
  if (item.produto) {
    if (item.produto.unidade.tipo === POR_PESO_VARIAVEL_SEM_UNIDADE) {
      if (item.produto.nivelCaixa) {
        return item.unidadesCaixaFinal > 0;
      }
      return item.pesoFinal > 0;
    }

    if (item.produto.nivelCaixa) {
      return item.unidadesCaixaFinal > 0;
    }
    return item.unidadesFinal > 0;
  }
  return '-';
}

const reducer = (state, action) => {
  let arrayNew = state.itens.slice();
  switch (action.type) {
    case 'ADD_ITEM': {
      const item = state.itensEstoque.find(
        (item) => item.id === action.item.item_venda_id,
      );

      item.unidadesFinal -= action.item.unidades;
      item.pesoFinal -= action.item.peso;
      item.unidadesCaixaFinal -= action.item.unidadesCaixaAparente;

      item.usado = !isEstoqueAcabado(item);

      return {
        ...state,
        itens: [...arrayNew, action.item],
        subTotal: getSubTotal([...arrayNew, action.item]),
      };
    }

    case 'REMOVE_ITEM': {
      const uuids = [];
      for (let i = 0; i < action.indices.length; i++) {
        const itemNormal = state.itens[action.indices[i]];
        uuids.push(itemNormal.uidd);
        const item = state.itensEstoque.find(
          (item) => item.id === itemNormal.item_venda_id,
        );

        item.unidadesFinal += itemNormal.unidades;
        item.pesoFinal += itemNormal.peso;
        item.unidadesCaixaFinal += itemNormal.unidadesCaixaAparente;

        item.usado = !isEstoqueAcabado(item);
      }

      for (let i = 0; i < uuids.length; i += 1) {
        arrayNew = arrayNew.filter((obj) => obj.uidd !== uuids[i]);
      }
      return {
        ...state,
        itens: [...renameItensUIDD(arrayNew)],
        subTotal: getSubTotal([...arrayNew]),
      };
    }

    case 'UPDATE_ITEMS':
      return {
        ...state,
        itens: [...renameItensUIDD(action.itens)],
        subTotal: getSubTotal([...action.itens]),
      };

    case 'RESETAR_TUDO':
      return {
        ...state,
        vendaId: -1,
        cliente: null,
        itens: [],
        itensEstoque: [],
        subTotal: 0,
        venda: null,
      };

    case 'PREENCHER_TUDO':
      return {
        ...state,
        vendaId: action.vendaId,
        itens: [...renameItensUIDD(action.itens)],
        cliente: action.cliente,
        itensEstoque: [...renameItensUIDD(action.itensEstoque)].map((item) => ({
          ...item,
          usado: false,
          unidadesFinal: item.unidades,
          pesoFinal: item.peso,
          unidadesCaixaFinal: item.unidadesCaixaAparente,
        })),
        subTotal: getSubTotal([...action.itens]),
        venda: action.venda,
      };
    case 'CARREGAR_RESTANTE':
      return state;
    /*return {
        ...state,
        itens: [...renameItensUIDD(state.itensEstoque)].map((item) => ({
          produto: item.produto,
          peso: item.peso,
          unidades: item.unidades,
          uidd: -1,
          idIndicadorChange: -1,
          unidadesCaixa: 0,
          pesoCaixa: 0,
          unidadesCaixaAparente: 0,
          nivelCaixaria: 0,
        })),
        itensEstoque: [...renameItensUIDD(state.itensEstoque)].map((item) => ({
          ...item,
          usado: true,
          unidadesFinal: 0,
          pesoFinal: 0,
          unidadesCaixaFinal: 0,
        })),
      };*/
    default:
      return state;
  }
};

export default reducer;
